import { default as React, ReactNode } from "react";
import { MessageFormatElement } from "react-intl";
import { PageMetadata } from "../../model/metadata";

import { SiteArea } from "../../utils/analytics";

import { WindowLocation } from "@reach/router";
import "@reach/skip-nav/styles.css";
import { GlobalMenus } from "../../model/menu";
import PageLayoutContent from "../PageLayoutContent/PageLayoutContent";
import Providers from "../Providers/Providers";

export interface PageLayoutProps {
  menus: GlobalMenus;
  children: ReactNode;
  metadata: PageMetadata;
  location: WindowLocation;
  messages: Record<string, MessageFormatElement[]>;
  siteArea: SiteArea;
  isErrorPage?: boolean;
}

const PageLayout = ({
  location,
  messages,
  siteArea,
  children,
  metadata,
  menus,
  isErrorPage = false
}: PageLayoutProps) => {
  const language = metadata.page.language ?? "en";
  return (
    <Providers
      language={language}
      location={location}
      menus={menus}
      messages={messages}
      siteArea={siteArea}
    >
      <PageLayoutContent
        menus={menus}
        metadata={metadata}
        children={children}
        isErrorPage={isErrorPage}
      />
    </Providers>
  );
};

export default PageLayout;
